// extracted by mini-css-extract-plugin
export var mainNavigation = "navigation-main-module--main-navigation--G3JUr";